<div class="ppLogin_content">
  <div class="ppLogin_header">
    <i class="icon-backarrow" (click)="goBack()"></i>
    {{ 'MODULES.LOGIN.RESET_PASSWORD' | transloco }}
  </div>
  <div class="ppLogin_body">
    <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()">
      <div class="loginBody-content">
        <h1 class="loginTitle">{{ 'MODULES.LOGIN.SET_YOUR_PASSWORD' | transloco }}</h1>
        
        <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': email?.invalid && email?.touched }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL_ADDRESS' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="email" matInput type="email" required maxlength="100" />
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="email?.invalid && email?.touched">
            <span *ngIf="email?.errors?.['required']">{{ 'MODULES.LOGIN.EMAIL_FIELD_EMPTY' | transloco }}</span>
            <span *ngIf="email?.errors?.['email'] || email?.errors?.['pattern']">{{ 'MODULES.LOGIN.INVALID_EMAIL' | transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': password?.invalid && password?.touched }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="password" matInput [type]="showPassword ? 'text' : 'password'" required maxlength="100" />
            <span (click)="showPassword = !showPassword" class="eye loginIcon" [ngClass]="{
                'icon-pswdHide': !showPassword,
                'icon-pswdShow': showPassword
              }"></span>
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="password?.invalid && password?.touched">
            <span *ngIf="password?.errors?.['required']">{{ 'MODULES.LOGIN.PASSWORD_REQUIRED' | transloco }}</span>
            <span *ngIf="password?.errors?.['passwordStrength']">{{ 'MODULES.LOGIN.PASSWORD_PATTERN' | transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap" 
             [ngClass]="{ 'dsFieldError': (confirmPassword?.invalid && confirmPassword?.touched) || 
                          resetPasswordForm.errors?.['mismatch'] }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="confirmPassword" matInput 
                   [type]="showConfirmPassword ? 'text' : 'password'" 
                   required maxlength="100" />
            <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon" [ngClass]="{
                'icon-pswdHide': !showConfirmPassword,
                'icon-pswdShow': showConfirmPassword
              }"></span>
          </mat-form-field>
          <div class="dsErrorMsg" 
               *ngIf="(confirmPassword?.invalid && confirmPassword?.touched) || resetPasswordForm.errors?.['mismatch']">
            <span *ngIf="confirmPassword?.errors?.['required'] && !resetPasswordForm.errors?.['mismatch']">
              {{ 'MODULES.LOGIN.CONFIRM_PASSWORD_REQUIRED' | transloco }}
            </span>
            <span *ngIf="resetPasswordForm.errors?.['mismatch'] && confirmPassword?.touched">
              {{ 'MODULES.LOGIN.PASSWORD_MISMATCH' | transloco }}
            </span>
          </div>
        </div>
      </div>

      <footer class="loginBody-footer">
        <button type="submit" class="loginAction_btn" [disabled]="!resetPasswordForm.valid">
          {{ 'HOME.SUBMIT' | transloco }}
        </button>
      </footer>
    </form>
  </div>
  <div class="login-copyright">
    {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
  </div>
</div>
